import React from "react";
import { Notifier } from "../../../components/notifier/Notifier";
import { DeleteContract } from "./DeleteContract";
import { PrimaryContact } from "./primaryContact/PrimaryContact";
import { SendForConfirmation } from "./SendForConfirmation";
import { Stores } from "./stores/Stores";
import { Uploads } from "./uploads/Uploads";
import { Offering } from "./offering/Offering";
import { CompanyData } from "./companyData/CompanyData";
import { FinancialData } from "./financialData/FinancialData";
import { SalesData } from "./salesData/SalesData";
import { ReadOnly } from "./readOnly/ReadOnly";
import { Notes } from "./notes/Notes";
import { useContract } from "../../../hooks/useContract";
import { isContractDisabled } from "../../../App";
import {
  Contract,
  ContractStatus,
  ProductType,
} from "../../../data/models/ContractTypes";
import { T } from "../../../components/translation/T";
import { FinancialEstimates } from "./financialEstimates/FinancialEstimates";
import { Invoices } from "./invoices/Invoices";

export function includeInvoicing(contract: Contract): boolean {
  return (
    contract.productType === ProductType.BAMBORA_ONE ||
    contract.productType === ProductType.BAMBORA_ONE_SHORT_TERM ||
    contract.productType === ProductType.BAMBORA_DEVICE ||
    contract.productType === ProductType.BAMBORA_DEVICE_SHORT_TERM
  );
}

export const LinkAnchors = {
  PRIMARY_CONTACT: { name: "Primary contact", anchor: "primary-contact" },
  COMPANY_DATA: { name: "Company data", anchor: "company-data" },
  FINANCIAL_DATA: {
    name: "Business Purpose",
    anchor: "financial-data",
  },
  FINANCIAL_ESTIMATES: {
    name: "Financial Estimates",
    anchor: "financial-estimates",
  },
  INVOICING: {
    name: "Invoicing",
    anchor: "invoices",
  },
  SALES_DATA: {
    name: "Sales data",
    anchor: "sales-data",
  },
  OFFERING: { name: "Offering", anchor: "offering" },
  PRICING: {
    name: "Pricing",
    anchor: "pricing",
  },
  STORES: {
    name: "Locations",
    ecomName: "Ecom settings",
    anchor: "stores",
  },
  DOCUMENT_COLLECTION: {
    name: "Company Identification",
    anchor: "document-collection",
  },
  NOTES: {
    name: "Notes",
    anchor: "notes",
  },
  UPLOADS: { name: "Documents", anchor: "documents" },
};

export const ContractEdit = () => {
  const contract = useContract();

  if (contract.status === ContractStatus.CANCELLED) {
    return (
      <div style={{ marginTop: "80px" }}>
        <h1>{contract.contractData.companyName}</h1>
        <p className="empty-timeline">
          <T>This contract has been deleted</T>
        </p>
      </div>
    );
  }

  let idOffset = 1;
  let renderInvoicing = false;
  if (includeInvoicing(contract)) {
    idOffset = 0;
    renderInvoicing = true;
  }

  return (
    <div className="contract-edit">
      <Notifier />

      <ReadOnly />

      <hr />
      <hr />

      <PrimaryContact id={1} />

      <hr />
      <hr />

      <CompanyData id={2} />

      <hr />
      <hr />

      <FinancialData id={3} />

      <hr />
      <hr />

      <FinancialEstimates id={4} />

      {renderInvoicing && (
        <>
          <hr />
          <hr />
          <Invoices id={5} />
        </>
      )}

      <hr />
      <hr />

      <SalesData id={6 - idOffset} />

      <hr />
      <hr />

      <Offering id={7 - idOffset} />

      <hr />
      <hr />

      <Stores id={8 - idOffset} />

      <hr />
      <hr />

      <Uploads id={9 - idOffset} />

      <hr />
      <hr />

      <Notes disabled={isContractDisabled(contract)} />

      <hr />
      <hr />

      <SendForConfirmation />

      <DeleteContract />
    </div>
  );
};
